import { render, staticRenderFns } from "./LandPageParceiro.vue?vue&type=template&id=92031646&scoped=true"
import script from "./LandPageParceiro.vue?vue&type=script&lang=js"
export * from "./LandPageParceiro.vue?vue&type=script&lang=js"
import style0 from "./LandPageParceiro.vue?vue&type=style&index=0&id=92031646&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92031646",
  null
  
)

export default component.exports